import * as React from "react";
import styled, { css } from "styled-components";

interface IProps {
  className?: string;
  fill?: string;
}

const STarget = styled.svg<IProps>`
  ${(props) =>
    props.fill &&
    css`
      fill: ${props.fill};
    `}
`;

const Target = ({ className, fill }: IProps) => {
  return (
    <STarget
      className={className}
      fill={fill}
      width="16"
      height="16"
      viewBox="0 0 512 512"
    >
      <g>
        <g>
          <path
            d="M266.8,245.685c-0.084-0.088-0.108-0.205-0.194-0.291l-85.604-85.605v-53.789c0-3.985-1.582-7.793-4.394-10.606
                    l-90-90.999C82.331,0.119,75.871-1.185,70.26,1.144c-5.61,2.314-9.258,7.793-9.258,13.857v45h-46
                    C8.939,60,3.46,63.647,1.146,69.258c-2.329,5.61-1.04,12.056,3.252,16.348l91,90.999c2.813,2.813,6.621,4.395,10.605,4.395h53.789
                    l85.604,85.604c0.086,0.086,0.203,0.11,0.291,0.194c5.84,5.574,14.711,5.648,20.629,0
                    C272.548,260.85,272.408,251.56,266.8,245.685z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M256.001,0.002c-38.381,0-74.67,9.765-107.348,25.018l46.014,46.014c19.312-6.422,39.895-10.032,61.335-10.032
                    C363.521,61.001,451,148.481,451,256s-87.479,194.999-194.999,194.999S61.002,363.52,61.002,256
                    c0-21.44,3.611-42.023,10.032-61.335l-46.014-46.014C9.769,181.33,0.003,217.619,0.003,256
                    c0,140.609,115.389,255.999,255.998,255.999S512,396.609,512,256S396.612,0.002,256.001,0.002z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M256.001,121.001c-15.855,0-30.855,3.25-45,8.293v18.074l34.677,34.677c3.406-0.476,6.788-1.044,10.323-1.044
                    c41.353,0,75,33.647,75,75c0,41.353-33.647,75-75,75c-41.353,0-75-33.647-75-75c0-3.536,0.568-6.918,1.044-10.323L147.369,211
                    h-18.074c-5.043,14.145-8.293,29.145-8.293,45c0,74.443,60.557,134.999,134.999,134.999S391.001,330.443,391.001,256
                    S330.444,121.001,256.001,121.001z"
          />
        </g>
      </g>
    </STarget>
  );
};

export default Target;
